import Content from '../components/icon-switching-content/ss-wrap.svelte'

export default {
	init() {
		let $contentWrap = $('#sc_inner')

		if ($contentWrap.length) {
			new Content({
				target: $contentWrap[0],
				props: $contentWrap.data(),
			})
		}
	},
}
